import React from 'react';
import type { InventoryItem } from '../warehouseInventoryTypes';
import styles from './InventoryTable.module.css';

interface InventoryTableProps {
  items: InventoryItem[];
  onViewDetails: (item: InventoryItem) => void;
}

export const InventoryTable: React.FC<InventoryTableProps> = ({ items, onViewDetails }) => {
  return (
    <div className={styles.tableWrapper}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th className={styles.th}>SKU</th>
            <th className={styles.th}>BARCODE</th>
            <th className={styles.th}>CATEGORY</th>
            <th className={styles.th}>TOTAL QUANTITY</th>
            <th className={styles.th}>RESERVED</th>
            <th className={styles.th}>AVAILABLE</th>
            <th className={styles.th}>LOCATION</th>
            <th className={styles.th}>ACTION</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item) => (
            <tr key={item.id} className={styles.row}>
              <td className={styles.td}>{item.sku}</td>
              <td className={styles.td}>{item.barcode || '—'}</td>
              <td className={styles.td}>{item.category}</td>
              <td className={`${styles.td} ${styles.totalQty}`}>{item.totalQuantity}</td>
              <td className={styles.td}>{item.reserved}</td>
              <td className={`${styles.td} ${styles.available}`}>{item.available}</td>
              <td className={styles.td}>
                <span className={styles.locationBadge}>{item.location}</span>
              </td>
              <td className={styles.td}>
                <button
                  className={styles.viewButton}
                  onClick={() => onViewDetails(item)}
                >
                  View Details
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
